export const nthChildPopup = (editor) => {
  const nthChildDiv = document.querySelector("#nth-child-select");
  if (nthChildDiv.classList.contains("d-none")) {
    nthChildDiv.classList = "";
    nthChildDiv.innerHTML = "";
  }

  const nthChildStateName = "nth-child";
  const selectedElement = editor.getSelectedToStyle();
  const selectorNameWithoutNthChild = selectedElement.getSelectorsString().replace(`:${nthChildStateName}`, "");

  const closePopup = () => {
    nthChildDiv.className = "d-none";
  };
  const getPattern = (state) => state.replace(nthChildStateName, "").replace("(", "").replace(")", "");

  const updateAllNthChildSelectorsWithCorrectState = () => {
    editor.CssComposer.getRules().forEach((rule) => {
      if (rule.get("state") === "" && rule.get("selectorsAdd").includes(nthChildStateName)) {
        const nthChildState = rule.get("selectorsAdd").split(":")[1];
        rule.set("state", nthChildState);
      }
    });
  };

  const getNthChildCssRules = (stateName = `${nthChildStateName}(`) => {
    const nthChildRules = editor.CssComposer.getRules().filter((rule) =>
      rule.selectorsToString().startsWith(`${selectorNameWithoutNthChild}:${stateName}`)
    );
    const nthChildSelectors = [];
    const nthChildFinalRules = [];
    nthChildRules.forEach((rule) => {
      const selectorString = rule.selectorsToString();
      if (!nthChildSelectors.includes(selectorString)) {
        nthChildFinalRules.push(rule);
        nthChildSelectors.push(selectorString);
      } else {
        editor.CssComposer.remove(rule);
      }
    });

    return nthChildFinalRules;
  };

  const isPatternExists = (pattern) => {
    const stateName = `${nthChildStateName}(${pattern})`;
    const existingRules = getNthChildCssRules(stateName);
    const existingRulesSelectors = existingRules.map((rule) => rule.get("state"));
    return existingRulesSelectors.includes(stateName);
  };

  const filterInputInvalidCharacters = (e) => {
    const regexPattern = /[^n0-9+-]/g;
  	if(e.currentTarget.tagName === "INPUT") {
      const initialValue = e.currentTarget.value.toString().trim();
      const finalValue = initialValue.replace(regexPattern, "");
    	e.currentTarget.value = finalValue;
    } else {
      const sel = window.getSelection();
      const initialValue = e.currentTarget.innerText.toString().trim();
      const finalValue = initialValue.replace(regexPattern, "");
      
      sel.extend(e.currentTarget, 0);
      let pos = sel.toString().length;
    
      e.currentTarget.innerText = finalValue;
      
      while(pos-- > 0) {
        sel.modify("move", "forward", "character");
      }
    }
  };

  const popupModal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
    <div style="padding-right: 17px;" class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded">
        <div class="modal-header">
          <div class="modal-title h5">Select nth-child pattern</div>&nbsp;
          <button class="btn-close" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <div>Component: ${selectorNameWithoutNthChild}</div>
          <hr />
          <div>Create new Pattern:</div>
          <div class="row">
            <div class="col-7">
              <input type="text" id="new-pattern" class="form-control rounded" placeholder="Enter the pattern e.g. 2n, 3n+2" />
            </div>
            <div class="col-5">
              <button id="cancel-new-pattern" class="btn btn-secondary">Cancel</button>
              <button id="submit-new-pattern" class="btn btn-primary">Submit</button>
            </div>
          </div>
          <hr />
          <div>Existing Patterns:</div>
          <div id="prev-nth-child">Previous</div>
        </div>
      </div>
    </div>
  </div>
  <div class="fade modal-backdrop show"></div>`;

  nthChildDiv.innerHTML = popupModal;

  const closeBtn = document.querySelector("#nth-child-select .btn-close");
  closeBtn.addEventListener("click", () => {
    closePopup();
    editor.SelectorManager.setState("");
  });

  const appendNthChildSelectors = () => {
    const nthChildCssRules = getNthChildCssRules();

    let previousNthChildHTML = "";
    nthChildCssRules.forEach((cssRule) => {
      const ruleState = cssRule.get("state");
      previousNthChildHTML += `
        <div class="selector px-2" data-state="${ruleState}">
          <span class="state-name p-2">${getPattern(ruleState)}</span>
          <span class="use-pattern fa fa-check text-success" title="Use Pattern"></span>
          <span class="edit-pattern fa fa-pencil-square text-warning" title="Edit Pattern"></span>
          <span class="delete-pattern fa-regular fa-trash-can text-danger" title="Delete Pattern"></span>
        </div>`;
    });

    const prevNthChildSelectorsGroup = document.querySelector("#nth-child-select #prev-nth-child");
    prevNthChildSelectorsGroup.innerHTML = previousNthChildHTML;

    const allPatternSpans = document.querySelectorAll("#prev-nth-child .use-pattern, #prev-nth-child .edit-pattern, #prev-nth-child .delete-pattern");

    const allSelectors = document.querySelectorAll("#prev-nth-child .selector");
    allSelectors.forEach((selectorButton) => {
      // add event listener to nameSpan to filter invalid characters
      selectorButton.querySelector(".state-name").addEventListener("input", filterInputInvalidCharacters);

      // click use to select state
      selectorButton.querySelector(".use-pattern").addEventListener("click", (e) => {
        e.stopPropagation();
        const stateValue = e.currentTarget.parentElement.getAttribute("data-state");
        editor.SelectorManager.setState(stateValue);
        closePopup();
      });

      // edit to change state name
      selectorButton.querySelector(".edit-pattern").addEventListener("click", (editEvent) => {
        editEvent.stopPropagation();
        const oldStateName = editEvent.currentTarget.parentElement.getAttribute("data-state");
        const stateNameSpan = editEvent.currentTarget.previousElementSibling.previousElementSibling;

        stateNameSpan.setAttribute("contenteditable", true);
        stateNameSpan.focus();

        allPatternSpans.forEach((el) => {
          el.style.display = "none";
        })

        stateNameSpan.addEventListener(
          "blur",
          (blurEvent) => {
            if (window.confirm("Are you sure?")) {
              const newStatePattern = blurEvent.currentTarget.innerText;
              const newStateName = `${nthChildStateName}(${newStatePattern})`;
              blurEvent.currentTarget.parentElement.setAttribute("data-state", newStateName);

              // const oldRules = editor.CssComposer.getRules(selectorNameWithoutNthChild).filter((rule) => rule.get("state") === oldStateName);
              const oldRules = getNthChildCssRules(oldStateName);
              oldRules.forEach((rule) => {
                rule.set("state", newStateName);
                if (rule.get("selectorsAdd") !== "") rule.set("selectorsAdd", `${selectorNameWithoutNthChild}:${newStateName}`);
              });
            } else {
              blurEvent.currentTarget.innerText = getPattern(oldStateName);
              blurEvent.currentTarget.parentElement.setAttribute("data-state", oldStateName);
            }
            blurEvent.currentTarget.removeAttribute("contenteditable");
            allPatternSpans.forEach((el) => {
              el.style.display = "inline";
            });
          },
          { once: true }
        );
      });

      // click delete to delete state
      selectorButton.querySelector(".delete-pattern").addEventListener("click", (deleteEvent) => {
        const stateName = deleteEvent.currentTarget.parentElement.getAttribute("data-state");
        if (window.confirm(`Are you sure you want to delete the following pattern\nPattern: ${stateName}`)) {
          const matchingRules = getNthChildCssRules(stateName);
          editor.CssComposer.remove(matchingRules);

          appendNthChildSelectors();
        }
      });
    });
  };

  const addNewNthChildPattern = () => {
    const newPatternInput = document.querySelector("#nth-child-select #new-pattern");
    const submitPatternButton = document.querySelector("#nth-child-select #submit-new-pattern");
    const cancelPatternButton = document.querySelector("#nth-child-select #cancel-new-pattern");

    const clearNewInput = () => {
      newPatternInput.value = "";
    };

    newPatternInput.addEventListener("input", filterInputInvalidCharacters);

    submitPatternButton.addEventListener("click", (e) => {
      const newPattern = newPatternInput.value.toString().trim();
      if (newPattern === "") {
        alert("Please enter some pattern!!!");
      } else if (isPatternExists(newPattern)) {
        alert(`${newPattern} already exists. Please enter some different pattern!!`);
        clearNewInput();
      } else {
        if (window.confirm(`Are you sure?`)) {
          // create new pattern
          const newNthChildString = `${selectorNameWithoutNthChild}:${nthChildStateName}(${newPattern})`;
          const newRule = editor.CssComposer.addRules(`${newNthChildString} {}`);
          newRule.forEach((rule) => rule.set("state", `${nthChildStateName}(${newPattern})`));

          clearNewInput();
          appendNthChildSelectors();
        }
      }
    });

    cancelPatternButton.addEventListener("click", (e) => {
      clearNewInput();
    });
  };

  updateAllNthChildSelectorsWithCorrectState();
  appendNthChildSelectors();
  addNewNthChildPattern();
};